/*
接口请求函数模块
 */
import ajax from "./ajax";
import { apiServer } from "@/util";
import { Loading } from "element-ui";

//获取所有用户
export const requestGetAllSysUserTableList = (param) => {
  return ajax(apiServer + "sysUser/grid", param, "POST", true);
};

// 请求申请
export const requestAddApply = (param) => {
  return ajax(apiServer + "apply/addApply", param, "POST", true);
};

// 请求详情
export const requestGetApply = (param) => {
  return ajax(apiServer + "apply/getApply", param, "POST", true);
};

// 申请列表
export const requestApplyList = (param) => {
  return ajax(apiServer + "tbUserApply/myApply", param, "POST", true);
};

// 各申请状态的数量
export const requestApplyCount = (param) => {
  return ajax(
    apiServer + "tbUserApply/getApplyStatusCount",
    param,
    "POST",
    true
  );
};

// 审批记录
export const requestMyAuditRecord = (param) => {
  return ajax(apiServer + "tbAudit/myAuditRecord", param, "POST", true);
};
// 我的待审核
export const requestMyWaitAudit = (param) => {
  return ajax(apiServer + "tbUserApply/myWaitAudit", param, "POST", true);
};

//新增保存用户
export const requestSaveSysUser = (param) => {
  return ajax(apiServer + "sysUser/addOrEdit", param, "POSTJSON", true);
};
//启禁用用户
export const requestDisableSysUser = (param) => {
  return ajax(apiServer + "sysUser/disable", param, "POST", true);
};

//获取所有机构
export const requestGetAllSysDeptTableList = (param) => {
  return ajax(apiServer + "sysDept/grid", param, "POST", true);
};

//禁用或启用机构
export const requestDisableSysDept = (param) => {
  return ajax(apiServer + "sysDept/disableSysDept", param, "POST", true);
};

//删除机构
export const requestDeleteSysDept = (param) => {
  return ajax(apiServer + "sysDept/remove", param, "POST", true);
};
//保存编辑机构
export const requestSaveSysDept = (param) => {
  return ajax(apiServer + "sysDept/addOrEdit", param, "POST", true);
};

//删除系统设置
export const requestDeleteBaseSet = (param) => {
  return ajax(apiServer + "sysBaseSet/remove", param, "POST", true);
};
//保存系统设置
export const requestSaveBaseSet = (param) => {
  return ajax(apiServer + "sysBaseSet/addOrEdit", param, "POST", true);
};

//获取系统设置
export const requestGetAllBaseSetTableList = (param) => {
  return ajax(apiServer + "sysBaseSet/grid", param, "POST", true);
};

//禁用或启用系统设置
export const requestDisableBaseSet = (param) => {
  return ajax(apiServer + "sysBaseSet/disable", param, "POST", true);
};

//获取所有的用户
export const requestGetAllSysUser = (param) => {
  return ajax(apiServer + "sysUser/grid", param, "POST", true);
};
//解绑微信
export const requestUnbanding = (param) => {
  return ajax(apiServer + "sysUser/unbinding", param, "POST", true);
};

//获取所有的机构
export const requestGetSysDept = (param) => {
  return ajax(apiServer + "sysDept/getAllSysDept", param, "POST", true);
};
//获取所有的机构
export const requestGetAllBaseSet = (param) => {
  return ajax(apiServer + "baseSet/getAllBaseSet", param, "POST", true);
};

//获取机构树
export const requestGetSysDeptTree = (param) => {
  return ajax(apiServer + "sysDept/deptTree", param, "POST", false);
};
//获取所有外出
export const requestOutList = (param) => {
  return ajax(apiServer + "outReport/grid", param, "POST", false);
};
//获取外出人员
export const requestGetOutUsers = (param) => {
  return ajax(apiServer + "outReport/outUsers", param, "POST", false);
};

//查询设置的子列表设置
export const requestGetChildrenSet = (param) => {
  return ajax(apiServer + "baseSet/getChildrenSet", param, "POST", true);
};
//查询子机构
export const requestGetChildrenDept = (param) => {
  return ajax(apiServer + "sysDept/getSysDeptByParentId", param, "POST", false);
};

//查询机构
export const requestGetOneSysDeptById = (param) => {
  return ajax(apiServer + "sysDept/getOneSysDeptById", param, "POST", false);
};

//用户登录
export const requestUserLogin = (param) => {
  return ajax(apiServer + "api/loginSubmit", param, "POST", true);
};
//选取用户
export const requestUserGet = (param) => {
  return ajax(apiServer + "sysUser/getUser", param, "POST", true);
};

//获取所有岗位类型
export const requestGetChildrenSetBySetName = (param) => {
  return ajax(
    apiServer + "baseSet/getChildrenSetBySetName",
    param,
    "POST",
    true
  );
};

//个人中心修改用户信息
export const requestUpdateUserInfoById = (param) => {
  return ajax(
    apiServer + "sysUser/updateUserInfoById",
    param,
    "POSTJSON",
    true
  );
};

//修改个人密码
export const requestUpdatePasswordById = (param) => {
  return ajax(apiServer + "sysUser/updatePasswordById", param, "POST", true);
};

//发布站内信
export const requestSiteletterAdd = (param) => {
  return ajax(apiServer + "sysSiteLetter/add", param, "POST", true);
};

//获取站内信
export const requestSiteletterSelectListByData = (param) => {
  return ajax(apiServer + "sysSiteLetter/grid", param, "POST", true);
};

//已读站内信
export const requestSiteletterRead = (param) => {
  return ajax(apiServer + "sysSiteLetter/read", param, "POST", true);
};

//获取所有的日志
export const requestGetAllSysLog = (param) => {
  return ajax(apiServer + "sysLogger/grid", param, "POST", false);
};
//获取个人的日志
export const requestSysLogByUser = (param) => {
  return ajax(apiServer + "sysLogger/sysLogByUser", param, "POST", false);
};

//获取首页需要的信息
export const requestGetHomeInfoAndSite = (param) => {
  return ajax(
    apiServer + "tbUserApply/getHomeInfoAndSite",
    param,
    "POST",
    false
  );
};
//部门列表
export const requestGetDeptTreeGrid = (param) => {
  return ajax(apiServer + "sysDept/deptTreeGrid", param, "POST", false);
};

/**/

// 查询所有人
export const requestAllUser = (param) => {
  return ajax(apiServer + "sysUser/getUser", param, "POST", false);
};

// 查询所有项目
export const requestAllProject = (param) => {
  return ajax(apiServer + "project/allProject", param, "POST", false);
};

export const requestManageProject = (param) => {
  return ajax(apiServer + "project/manageProject", param, "POST", false);
};

export const requestAddProjectModify = (param) => {
  return ajax(apiServer + "projectModify/add", param, "POST", false);
};

// 查询自己负责的项目信息
export const requestOwnProjectPage = (param) => {
  return ajax(apiServer + "project/grid", param, "POST", false);
};
// 查询所有项目信息
export const requestAllProjectPage = (param) => {
  return ajax(apiServer + "project/projectDetail", param, "POST", false);
};

// 导出项目excel
export const exportAllProject = (param) => {
  return ajax(apiServer + "project/exportAllProject", param, "POST", false);
};

// 立项申请
export const requestProjectApply = (param) => {
  return ajax(apiServer + "project/projectApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 获取项目编号前缀
export const requestProjectPrefix = (param) => {
  return ajax(apiServer + "project/getProjectPrefix", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 招待费报备
export const requestCostReportApply = (param) => {
  return ajax(apiServer + "costReport/costReportApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 付款申请
export const requestPaymentApply = (param) => {
  return ajax(apiServer + "payment/paymentApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

//外出申请
export const requestOutReportApply = (param) => {
  return ajax(apiServer + "outReport/outApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

//请假申请
export const requestLeaveApply = (param) => {
  return ajax(apiServer + "leave/leaveApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

//获取请假列表
export const requestLeaveList = (param) => {
  return ajax(apiServer + "leave/leaveList", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 导出所有请假
export const requestExportLeave = (param) => {
  return ajax(apiServer + "leave/exportLeave", param, "POST", false);
};

// 获取已用年假
export const requestGetAnnualLeave = (param) => {
  return ajax(apiServer + "leave/getAnnualLeave", param, "GET", false);
};
// 获取用户已用年假
export const requestGetAnnualLeaveByUserId = (userId) => {
  return ajax(apiServer + "leave/getAnnualLeaveByUserId", { userId: userId }, "GET", false);
};
//用章申请
export const requestSealApply = (param) => {
  return ajax(apiServer + "seal/sealApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 项目文件归档申请
export const requestContractApply = (param) => {
  return ajax(apiServer + "contract/add", param, "BODY", false, {
    text: "申请中，请稍等...",
  });
};

// 备用金申请
export const requestPettyCashApply = (param) => {
  return ajax(apiServer + "pettyCash/pettyCashApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 所有备用金申请
export const requestAllPettyCashApply = (param) => {
  return ajax(apiServer + "pettyCash/grid", param, "POST", false);
}

// 导出付款申请
export const requestPrintPettyCash = (param) => {
  return ajax(apiServer + "pettyCash/print", param, "POST", false);
};

// 所有合同查询
export const requestAllContract = (param) => {
  return ajax(apiServer + "contract/grid", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 合同回款
export const requestPayback = (param) => {
  return ajax(apiServer + "contract/payback", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};
// 查询回款记录 getPaybackRecords
export const requestGetPaybackRecords = (param) => {
  return ajax(apiServer + "contract/getPaybackRecords", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 删除回款
export const requestDelPayback = (param) => {
  return ajax(apiServer + "contract/deletePayback", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 更新合同回款进度
export const requestUpdatePaybackProcess = (param) => {
  return ajax(
    apiServer + "contract/updatePaybackProcess",
    param,
    "POST",
    false,
    { text: "申请中，请稍等..." }
  );
};

// 查询合同详细信息
export const requestGetContractInfo = (param) => {
  return ajax(apiServer + "contract/getContractInfo", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 根据项目ID查询合同列表
export const requestGetContractInfoByProjectId = (param) => {
  return ajax(apiServer + "contract/getContractInfoByProjectId", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 实施档案管理
export const requestEnforceApply = (param) => {
  return ajax(apiServer + "enforce/add", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 实施档案查询
export const requestEnforceFile = (param) => {
  return ajax(apiServer + "enforce/getFile", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

export const requestCoworkingApply = (param) => {
  return ajax(
    apiServer + "coWorking/coWorkingApply",
    param,
    "POSTJSON",
    false,
    { text: "申请中，请稍等..." }
  );
};

// 采购申请
export const requestPurchaseApply = (param) => {
  return ajax(apiServer + "purchase/purchaseApply", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 采购清单回填
export const requestPurchaseBack = (param) => {
  return ajax(apiServer + "purchase/purchaseBackFill", param, "POST", false, {
    text: "申请中，请稍等...",
  });
};

// 考勤申述
export const requestAllegeApply = (param) => {
  return ajax(apiServer + "allege/addAllege", param, "BODY", false, {
    text: "申请中，请稍等...",
  });
};

//待办列表
export const requestDealtGrid = (param) => {
  return ajax(apiServer + "tbWaitDealt/grid", param, "POST", false);
};
//所有人待办列表
export const requestEveryOneGrid = (param) => {
  return ajax(apiServer + "tbWaitDealt/everyOneGrid", param, "POST", false);
};
//添加待办
export const requestAddDealt = (param) => {
  return ajax(apiServer + "tbWaitDealt/add", param, "POST", false);
};
//助理给人添加待办
export const requestAddDealtOther = (param) => {
  return ajax(apiServer + "tbWaitDealt/addOther", param, "POST", false);
};
//添加待办
export const requestDeleteDealt = (param) => {
  return ajax(apiServer + "tbWaitDealt/remove", param, "POST", false);
};
//完成待办
export const requestCompleteDealt = (param) => {
  return ajax(apiServer + "tbWaitDealt/success", param, "POST", false);
};

//获取审批类型列表
export const requestFlowGrid = (param) => {
  return ajax(apiServer + "tbFlow/grid", param, "POST", false);
};
//获取所有审批类型
export const requestFlowList = (param) => {
  return ajax(apiServer + "tbFlow/list", param, "POST", false);
};
//获取审批流程列表
export const requestLineList = (param) => {
  return ajax(apiServer + "tbFlowLine/grid", param, "POST", false);
};
//添加或编辑审批流程
export const requestAddOrEditFlowLine = (param) => {
  return ajax(apiServer + "tbFlowLine/add", param, "POST", false);
};
//删除审批流程
export const requestRemoveFlowLine = (param) => {
  return ajax(apiServer + "tbFlowLine/remove", param, "POST", false);
};

//获取所有角色
export const requestRoleList = (param) => {
  return ajax(apiServer + "sysRole/list", param, "POST", false);
};
//获取所有角色
export const requestAllDept = (param) => {
  return ajax(apiServer + "sysDept/allDept", param, "POST", false);
};

//获取项目信息
export const requestProjectAllGet = (param) => {
  return ajax(apiServer + "project/allProject", param, "POST", false);
};

// 获取草稿
export const requestLastdraft = (param) => {
  return ajax(apiServer + "reimburse/getLastDraft", param, "POST", false);
};

// 报销申请
export const requestAddReimburse = (param) => {
  return ajax(apiServer + "reimburse/addReimburse", param, "POST", false);
};

// 所有费用申请
export const requestAllCostReport = (param) => {
  return ajax(apiServer + "costReport/allCostReport", param, "POST", false);
};

// 编辑报销名目
export const requestReimburseEdit = (param) => {
  return ajax(apiServer + "reimburse/edit", param, "POST", false);
};

// 删除报销名目
export const requestReimburseRemove = (param) => {
  return ajax(apiServer + "reimburse/remove", param, "POST", false);
};
/**/
// 获取申请详情
export const requestApplyDetail = (param) => {
  return ajax(apiServer + "tbUserApply/applyDetail", param, "POST", false);
};

// 获取报销人外出记录
export const requestGetOutRecord = (param) => {
  return ajax(apiServer + "reimburse/getOutRecord", param, "POST", false);
};

// 打印报销
export const requestPrintReimburse = (param) => {
  return ajax(apiServer + "reimburse/print", param, "POST", false);
};
// 按月打印报销
export const requestPrintReimburseByMonth = (param) => {
  return ajax(apiServer + "reimburse/printByMonth", param, "POST", false);
};

// 审核
export const requestAudit = (param) => {
  return ajax(apiServer + "tbAudit/audit", param, "POST", false, {
    text: "审核中，请稍等...",
  });
};

// 所有申请
export const requestAllApply = (param) => {
  return ajax(apiServer + "tbUserApply/viewApply", param, "POST", false);
};

// 所有已交付的项目申请
export const requestAllDeliveryApply = (param) => {
  return ajax(apiServer + "tbUserApply/viewProjectDeliveryApply", param, "POST", false);
}

// 我的及下属所有已交付项目申请
export const ownProjectDeliveryApply = (param) => {
  return ajax(apiServer + "tbUserApply/ownProjectDeliveryApply", param, "POST", false);
}

// 所有已付款申请
export const requestAllPaymentApply = (param) => {
  return ajax(apiServer + "payment/grid", param, "POST", false);
}

// 导出付款申请
export const requestPrintPayment = (param) => {
  return ajax(apiServer + "payment/print", param, "POST", false);
};

// 导出所有申请
export const requestExportAllApply = (param) => {
  return ajax(apiServer + "tbUserApply/exportAllApply", param, "POST", false);
};

// 所有内审单
export const requestAllReimburse = (param) => {
  return ajax(apiServer + "reimburse/list", param, "POST", false);
};

// 查询内审单详情
export const requestReimburseDetail = (param) => {
  return ajax(apiServer + "reimburse/reimburseDetail", param, "POST", false);
};

// 是否是当前人审核
export const requestAuditShow = (param) => {
  return ajax(apiServer + "tbAudit/show", param, "POST", false);
};

// 查看招待费报备详情
export const requestCostReportDetail = (param) => {
  return ajax(apiServer + "costReport/infoById", param, "POST", false);
};

// 查看项目详情
export const requestProjectDetail = (param) => {
  return ajax(apiServer + "project/infoById", param, "POST", false);
};
// 登录
export const requestLogin = (param) => {
  return ajax(apiServer + "sysQrLogin/login", param, "POST", false);
};
// 获取登录token
export const requestGetToken = (param) => {
  return ajax(apiServer + "sysQrLogin/getToken", param, "POST", false);
};

// 查询转移记录列表
export const requestProjectShiftRecord = (param) => {
  return ajax(apiServer + "project/projectShiftRecord", param, "POST", false);
};

// 项目转移负责人
export const requestShiftProjectManager = (param) => {
  return ajax(apiServer + "project/shiftProjectManager", param, "POST", false);
};

// 导出所有外出
export const requestExportOutreport = (param) => {
  return ajax(apiServer + "outReport/exportOutReport", param, "POST", false);
};

// 撤回申请
export const requestCancelApply = (param) => {
  return ajax(apiServer + "tbUserApply/cancelApply", param, "POST", false);
};

export const requestExportReimburse = (param) => {
  return ajax(apiServer + "reimburse/export", param, "POST", false);
};

export const requestInvoice = (param) => {
  return ajax(apiServer + "invoice/add", param, "POST", false);
};

export const requestDelivery = (param) => {
  return ajax(apiServer + "delivery/add", param, "POST", false);
};
